var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { path: "/home/welcome" } } },
              [_c("div", { staticClass: "div1" }, [_vm._v("首页")])]
            ),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [
                _vm._v(_vm._s(_vm.breadcrumbTitle)),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content", staticStyle: { "padding-bottom": "40px" } },
      [
        _c("h2", [_vm._v(_vm._s(_vm.breadcrumbTitle))]),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "cuponForm",
                staticClass: "info-form",
                attrs: {
                  model: _vm.cuponForm,
                  rules: _vm.cuponRules,
                  "label-width": "150px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "优惠券名称", prop: "name" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "450px" },
                      attrs: {
                        placeholder: "请输入优惠券名称",
                        maxlength: "14",
                        "show-word-limit": "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.cuponForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.cuponForm, "name", $$v)
                        },
                        expression: "cuponForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "优惠券面值", prop: "value" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "350px" },
                      attrs: {
                        type: "number",
                        placeholder: "请输入优惠券面值",
                        clearable: "",
                      },
                      model: {
                        value: _vm.cuponForm.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.cuponForm, "value", $$v)
                        },
                        expression: "cuponForm.value",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "最低满足金额", prop: "limitValue" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "350px" },
                      attrs: {
                        type: "number",
                        placeholder: "请输入优惠券使用最低满足金额",
                        clearable: "",
                      },
                      model: {
                        value: _vm.cuponForm.limitValue,
                        callback: function ($$v) {
                          _vm.$set(_vm.cuponForm, "limitValue", $$v)
                        },
                        expression: "cuponForm.limitValue",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "起止时间", prop: "startEndTime" } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetimerange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                      },
                      model: {
                        value: _vm.cuponForm.startEndTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.cuponForm, "startEndTime", $$v)
                        },
                        expression: "cuponForm.startEndTime",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "有效时间", prop: "validDays" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "350px" },
                      attrs: {
                        oninput: "value=value.replace(/[^0-9]/g,'')",
                        type: "number",
                        placeholder: "请输入有效时间（天）",
                        clearable: "",
                      },
                      model: {
                        value: _vm.cuponForm.validDays,
                        callback: function ($$v) {
                          _vm.$set(_vm.cuponForm, "validDays", $$v)
                        },
                        expression: "cuponForm.validDays",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "优惠券发放数量", prop: "quantity" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        type: "number",
                        placeholder: "请输入优惠券发放数量",
                        clearable: "",
                      },
                      model: {
                        value: _vm.cuponForm.quantity,
                        callback: function ($$v) {
                          _vm.$set(_vm.cuponForm, "quantity", $$v)
                        },
                        expression: "cuponForm.quantity",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "每人限领数量", prop: "personelQuantity" },
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        type: "number",
                        placeholder: "请设置每人限领数量",
                        clearable: "",
                      },
                      model: {
                        value: _vm.cuponForm.personelQuantity,
                        callback: function ($$v) {
                          _vm.$set(_vm.cuponForm, "personelQuantity", $$v)
                        },
                        expression: "cuponForm.personelQuantity",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否显示", prop: "showFlag" } },
                  [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: "1" },
                        model: {
                          value: _vm.cuponForm.showFlag,
                          callback: function ($$v) {
                            _vm.$set(_vm.cuponForm, "showFlag", $$v)
                          },
                          expression: "cuponForm.showFlag",
                        },
                      },
                      [_vm._v("是")]
                    ),
                    _c(
                      "el-radio",
                      {
                        attrs: { label: "2" },
                        model: {
                          value: _vm.cuponForm.showFlag,
                          callback: function ($$v) {
                            _vm.$set(_vm.cuponForm, "showFlag", $$v)
                          },
                          expression: "cuponForm.showFlag",
                        },
                      },
                      [_vm._v("否")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "适用范围", prop: "scope" } },
                  _vm._l(_vm.dictionaries.coupon_scope, function (item, index) {
                    return _c(
                      "el-radio",
                      {
                        attrs: { label: item.dictId },
                        on: { change: _vm.getLimitChange },
                        model: {
                          value: _vm.cuponForm.scope,
                          callback: function ($$v) {
                            _vm.$set(_vm.cuponForm, "scope", $$v)
                          },
                          expression: "cuponForm.scope",
                        },
                      },
                      [_vm._v(_vm._s(item.dictName))]
                    )
                  }),
                  1
                ),
                _vm.cuponForm.scope
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "brand-id",
                        attrs: { label: "", prop: "user" },
                      },
                      [
                        _vm.cuponForm.scope == "2" || _vm.cuponForm.scope == "3"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "margin-right": "10px" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.cuponForm.scope == "2"
                                          ? "类目"
                                          : "标签"
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  { attrs: { type: "primary", size: "mini" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.cuponForm.scope == "2"
                                          ? "选择类目"
                                          : "选择标签"
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.cuponForm.scope == "2"
                          ? _c(
                              "div",
                              { staticClass: "cascabox" },
                              [
                                _c("el-cascader-panel", {
                                  key: _vm.cKey,
                                  ref: "cat",
                                  attrs: {
                                    options: _vm.categoryList,
                                    props: {
                                      multiple: true,
                                      checkStrictly: true,
                                      emitPath: false,
                                    },
                                  },
                                  on: { change: _vm.getCategoryChange },
                                  model: {
                                    value: _vm.selectedCategory,
                                    callback: function ($$v) {
                                      _vm.selectedCategory = $$v
                                    },
                                    expression: "selectedCategory",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.cuponForm.scope == "3"
                          ? _c("div", { staticClass: "cascabox table-incl" }, [
                              _c("div", { staticClass: "table-top" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "table-top-left",
                                    staticStyle: { "margin-bottom": "10px" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "primary-plain",
                                        on: {
                                          click: function ($event) {
                                            return _vm.batchSelectTag(1)
                                          },
                                        },
                                      },
                                      [_vm._v("批量选择")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "primary-plain",
                                        on: {
                                          click: function ($event) {
                                            return _vm.batchSelectTag(2)
                                          },
                                        },
                                      },
                                      [_vm._v("批量取消")]
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "goods-table" },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      ref: "tagTable",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: _vm.tagList,
                                        "header-cell-style": {
                                          background: "#F8F8F8",
                                          color: "#333333",
                                        },
                                      },
                                      on: {
                                        "selection-change":
                                          _vm.handleSelectionChange,
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: { type: "selection" },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "标签",
                                          prop: "tagName",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: { label: "排序", prop: "sort" },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "是否对外展示",
                                          prop: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.showFlag == 1
                                                          ? "是"
                                                          : "否"
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1702362856
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "状态",
                                          prop: "tagName",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "tag-status",
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass: "circle",
                                                        style: {
                                                          "background-color":
                                                            scope.row.status ==
                                                            1
                                                              ? "#67c23a"
                                                              : "red",
                                                        },
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row.status ==
                                                              1
                                                              ? "启用"
                                                              : "停用"
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3687303130
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: { label: "操作", prop: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  !scope.row.selected
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleSelectTag(
                                                                scope
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("选择")]
                                                      )
                                                    : _vm._e(),
                                                  scope.row.selected
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          staticStyle: {
                                                            color: "red",
                                                          },
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleSelectTag(
                                                                scope
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("取消")]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1498821920
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    overflow: "hidden",
                                    background: "#F5F5F5",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        "margin-top": "10px",
                                      },
                                    },
                                    [
                                      _c("el-pagination", {
                                        attrs: {
                                          background: "",
                                          "current-page": _vm.labelPageNo,
                                          "page-sizes": [5, 10, 20],
                                          "page-size": _vm.labelPageSize,
                                          layout:
                                            "total, sizes, prev, pager, next, jumper",
                                          total: _vm.labelTotalNum,
                                        },
                                        on: {
                                          "size-change": _vm.onSizeChange,
                                          "current-change": _vm.onCurrentChange,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm.cuponForm.scope == "4"
                          ? _c("div", { staticClass: "cascabox" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "table-top",
                                  staticStyle: { "margin-bottom": "20px" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "table-top-left" },
                                    [
                                      _c("span", [_vm._v("商品名称")]),
                                      _c("el-input", {
                                        staticStyle: {
                                          width: "200px",
                                          margin: "0 10px",
                                        },
                                        attrs: { placeholder: "商品名称" },
                                        model: {
                                          value: _vm.goodsName,
                                          callback: function ($$v) {
                                            _vm.goodsName = $$v
                                          },
                                          expression: "goodsName",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "primary-mini",
                                          staticStyle: {
                                            "line-height": "32px",
                                          },
                                          on: { click: _vm.checkGoodsList },
                                        },
                                        [_vm._v("查询")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "table-top-left" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "primary-plain",
                                        on: {
                                          click: function ($event) {
                                            return _vm.batchSelectGoods(1)
                                          },
                                        },
                                      },
                                      [_vm._v("批量选择")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "primary-plain",
                                        on: {
                                          click: function ($event) {
                                            return _vm.batchSelectGoods(2)
                                          },
                                        },
                                      },
                                      [_vm._v("批量取消")]
                                    ),
                                    _vm.showSelectedGoods
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "primary-plain",
                                            on: { click: _vm.handleShowSelect },
                                          },
                                          [_vm._v("已选择商品")]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "primary-plain",
                                            on: { click: _vm.handleShowSelect },
                                          },
                                          [_vm._v("选择商品")]
                                        ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "goods-table",
                                  staticStyle: { border: "1px solid #EBEEF5" },
                                },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      ref: "goodsTable",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: _vm.goodsList,
                                        "header-cell-style": {
                                          background: "#F8F8F8",
                                          color: "#333333",
                                        },
                                      },
                                      on: {
                                        "selection-change":
                                          _vm.handleGoodsSelectionChange,
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: { type: "selection" },
                                      }),
                                      _c("el-table-column", {
                                        attrs: { label: "商品ID", prop: "id" },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "商品名称",
                                          prop: "name",
                                          width: "250",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(scope.row.name)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1636329533
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "商品图片",
                                          prop: "imageUrl",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-image", {
                                                    staticClass: "table-image",
                                                    attrs: {
                                                      src: scope.row.imageUrl,
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          954409200
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "商品类型",
                                          prop: "typeFlagLabel",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.typeFlagLabel
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          176805608
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "商品状态",
                                          prop: "status",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "p",
                                                    {
                                                      style: {
                                                        color:
                                                          scope.row.status === 1
                                                            ? "#67c23a"
                                                            : "red",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            scope.row
                                                              .statusLabel
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2301155627
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: { label: "操作", prop: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  !scope.row.selected
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleSelectGoods(
                                                                scope
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("选择")]
                                                      )
                                                    : _vm._e(),
                                                  scope.row.selected
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          staticStyle: {
                                                            color: "red",
                                                          },
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleSelectGoods(
                                                                scope
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("取消")]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2302202528
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    overflow: "hidden",
                                    background: "#F5F5F5",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        "margin-top": "10px",
                                      },
                                    },
                                    [
                                      _c("el-pagination", {
                                        attrs: {
                                          background: "",
                                          "current-page": _vm.goodsPageNo,
                                          "page-sizes": [5, 10, 20],
                                          "page-size": _vm.goodsPageSize,
                                          layout:
                                            "total, sizes, prev, pager, next, jumper",
                                          total: _vm.goodsTotalNum,
                                        },
                                        on: {
                                          "size-change": _vm.onGoodsSizeChange,
                                          "current-change":
                                            _vm.onGoodsCurrentChange,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { staticStyle: { display: "inline-block" } },
                  [
                    _vm.cuponForm.scope == "2" && _vm.selectedCName.length > 0
                      ? _c("div", { staticClass: "selected" }, [
                          _c("span", [_vm._v("已选")]),
                          _c(
                            "div",
                            { staticClass: "selectedbox" },
                            _vm._l(_vm.selectedCName, function (item, index) {
                              return _c(
                                "div",
                                { staticClass: "selected-item" },
                                [
                                  _vm._v(" " + _vm._s(item) + " "),
                                  _c("div", { staticClass: "labeliconbox" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-circle-close labelicon",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteSelectedCName(index)
                                        },
                                      },
                                    }),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _vm.cuponForm.scope == "3" && _vm.seletedTag.length > 0
                      ? _c("div", { staticClass: "selected" }, [
                          _c(
                            "span",
                            { staticStyle: { "line-height": "28px" } },
                            [_vm._v("已选")]
                          ),
                          _c(
                            "div",
                            { staticClass: "selectedbox" },
                            _vm._l(_vm.seletedTag, function (item, index) {
                              return _c(
                                "div",
                                { staticClass: "selected-item" },
                                [
                                  _vm._v(" " + _vm._s(item.tagName) + " "),
                                  _c("div", { staticClass: "labeliconbox" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-circle-close labelicon",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteTag(index)
                                        },
                                      },
                                    }),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "brand-id",
                    attrs: { label: "适用用户", prop: "userScope" },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择适用用户",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.cuponForm.userScope,
                          callback: function ($$v) {
                            _vm.$set(_vm.cuponForm, "userScope", $$v)
                          },
                          expression: "cuponForm.userScope",
                        },
                      },
                      _vm._l(
                        _vm.dictionaries.coupon_user_scope,
                        function (item) {
                          return _c("el-option", {
                            key: item.dictId,
                            attrs: { label: item.dictName, value: item.dictId },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "brand-id",
                    attrs: { label: "优惠券类型", prop: "typeFlag" },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择优惠券类型",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.cuponForm.typeFlag,
                          callback: function ($$v) {
                            _vm.$set(_vm.cuponForm, "typeFlag", $$v)
                          },
                          expression: "cuponForm.typeFlag",
                        },
                      },
                      _vm._l(_vm.dictionaries.coupon_type, function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "content bottom-but" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "warning" },
                on: {
                  click: function ($event) {
                    return _vm.$router.go(-1)
                  },
                },
              },
              [_vm._v("返回")]
            ),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.submitFn } },
              [_vm._v("提交")]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }